@import '~style-sheet-helpers/core';
@import '../../../../app-brand/entities/entity-layer.module.less';

.active-groupby-column {
  background-color: @display-grid--grid-cell--background-color;
}
